<template>
  <v-container id="bid-equipment" fluid tag="section" class="main-container">
    <idc-component-bid-equipments v-bind="{ ...$props }" :settings="settings" />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import Path from '@/utilities/bid/enums/Path'
  import { mapState } from 'vuex'

  export default Vue.extend({
    name: 'DashboardBidEquipment',
    components: {
      IdcComponentBidEquipments: () => import('@/components/idc/bids/specification/equipment/Equipments'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canEdit: {
        type: Boolean,
        default: () => false,
      },
      canDelete: {
        type: Boolean,
        default: () => false,
      },
      urlSpecification: {
        type: String,
        default: () => Path.SALES_BIDS_SPEC,
      },
      bidNumber: {
        type: String,
        validator(value) {
          return /^ID-\d{4}-\d{4}$/.test(value)
        },
        default: () => '',
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
